export default __webpack_public_path__ + "static/international-metric-desktop-49117cc199e91851d7c8ddeac7a0bb58.svg";